import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/v1/Button';

export default function Frontend() {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    // Simulate async operation
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  return (
    <div className="bg-gray-900 min-h-screen w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Frontend
          </h1>

          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-semibold text-white mb-4">
                Button Component with Loading State
              </h2>
              <p className="text-gray-400 mb-6">
                Click the buttons below to see the loading state in action.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <Button 
                loading={isLoading} 
                onClick={handleClick}
                variant="primary"
              >
                Primary Button
              </Button>

              <Button 
                loading={isLoading} 
                onClick={handleClick}
                variant="secondary"
              >
                Secondary Button
              </Button>

              <Button 
                loading={isLoading} 
                onClick={handleClick}
                variant="outline"
              >
                Outline Button
              </Button>

              <Button 
                loading={isLoading} 
                onClick={handleClick}
                variant="danger"
              >
                Danger Button
              </Button>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-semibold text-white mb-4">
                Different Sizes
              </h3>
              <div className="flex flex-wrap items-center gap-4">
                <Button 
                  loading={isLoading} 
                  onClick={handleClick}
                  size="sm"
                >
                  Small Button
                </Button>

                <Button 
                  loading={isLoading} 
                  onClick={handleClick}
                  size="md"
                >
                  Medium Button
                </Button>

                <Button 
                  loading={isLoading} 
                  onClick={handleClick}
                  size="lg"
                >
                  Large Button
                </Button>
              </div>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-semibold text-white mb-4">
                Full Width
              </h3>
              <Button 
                loading={isLoading} 
                onClick={handleClick}
                fullWidth
              >
                Full Width Button
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
